<template>
  <quotes-portal-layout v-if="isQuotesPortal" />
  <portal-layout v-else />
</template>

<script setup lang="ts">
import { isQuotesPortal } from '@/helpers'
import PortalLayout from '@/layouts/PortalLayout.vue'
import QuotesPortalLayout from '@/layouts/QuotesPortalLayout.vue'
import { PageView } from '@/modules/tracking/events/pageView'
import { trackEvent } from '@/modules/tracking/useTracking'
import router from '@/router'
import { onMounted } from 'vue'

router.afterEach((from, to) => {
  if (from.path !== to.path && to.matched.some((record) => record.meta.requiresAuth)) {
    trackEvent(PageView)
  }
})

onMounted(() => {
  trackEvent(PageView)
})
</script>
